import { renderSlot } from 'vue';
/**
 * Renders a slot of the root data table from within a row component, falling
 * back to this component's default slot if the consumer did not provide one.
 *
 * `renderSlot()` is what `<slot>` compiles to, so the DOM (fragment anchors)
 * and the fallback semantics are the same as with a native slot. Handing the
 * slots object down instead of forwarding `v-for="(_, name) in $slots"` keeps
 * the rows' vnodes free of dynamic slots, so rows can skip re-rendering when
 * the root re-renders.
 */
const DataTableSlotOutlet = (props, { slots }) => {
    return renderSlot(props.slots, props.name, props.scope, slots.default);
};
DataTableSlotOutlet.props = {
    slots: { type: Object, required: true },
    name: { type: String, required: true },
    scope: { type: Object, required: false },
};
export default DataTableSlotOutlet;
